import { Component, OnDestroy, OnInit } from "@angular/core";
import { first, Observable, tap } from "rxjs";
import { I18nService } from "src/app/i18n/services";
import { HelpTarget, ICirculationInit } from "src/app/interfaces";
import { LogClass, Logger } from "src/app/logger";
import { NotificationService } from "src/app/notifications";
import { CirculationFacade, NavigationService } from "src/app/services";
import { SubSink } from "subsink";

@Component({
    selector: "start-multiple",
    templateUrl: "./start-multiple.component.html",
    styleUrls: ["./start-multiple.component.scss"],
    standalone: false
})
@LogClass({ source: "StartMultipleCirculationsComponent" })
export class StartMultipleCirculationsComponent implements OnInit, OnDestroy {
  public loading = true;
  public circulation$: Observable<ICirculationInit[]>;
  public disableStart = true;
  public readonly helpTarget = HelpTarget.Circulation;

  private logger: Logger;
  private subs = new SubSink();
  private selectedCirculations: ICirculationInit[] = [];

  constructor(
    private circulationFacade: CirculationFacade,
    private navigate: NavigationService,
    private notificationService: NotificationService,
    private i18n: I18nService
  ) {
    this.logger.debug("ctor");
  }

  public ngOnInit(): void {
    this.loading = true;
    this.circulationFacade.loadCirculations();
    this.circulation$ = this.circulationFacade.getStartableCirculations().pipe(
      tap(() => {
        this.loading = false;
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public onStartAllClicked() {
    if (this.selectedCirculations.length > 0) {
      this.loading = true;
      this.subs.sink = this.circulationFacade
        .startMultiple(this.selectedCirculations)
        .pipe(first())
        .subscribe({
          next: (e) => {
            if (e.success > 0) {
              this.subs.sink = this.i18n
                .get("startMultiple.successMessage")
                .pipe(first())
                .subscribe((m: string) =>
                  this.notificationService.success(
                    m.replace("%1", e.success.toString())
                  )
                );
            }
            if (e.fails > 0) {
              this.subs.sink = this.i18n
                .get("startMultiple.failMessage")
                .pipe(first())
                .subscribe((m: string) =>
                  this.notificationService.warning(
                    m.replace("%1", e.fails.toString())
                  )
                );
            }
            // todo: messages??
            this.navigate.toCirculationOverview();
          },
          error: (e) => {
            this.navigate.toError(e);
          }
        });
    }
  }

  public onSelectionChanged(e: ICirculationInit[]) {
    this.disableStart = e.length < 1;
    this.selectedCirculations = e;
  }
}
